<div style="display: flex;flex-direction: column;width: 100%;">
    <div
        style="display: flex;justify-content: space-between;height: 45px;align-items: center; color:#0c3691eb;padding: 0 0.5rem;">
        <div style="display: flex;flex-direction: row;align-items: center;">
            <span multilang style="font-size: 1rem;font-weight: 600;">{{name}}</span>
        </div>
        <span multilang mat-dialog-close style="cursor: pointer;">
            <!--mat-icon >close</mat-icon-->
        </span>
    </div>
</div>

<ng-container *ngTemplateOutlet="desktopTemplate ? modeDesk: modeMobile"></ng-container>

<ng-template #modeDesk>
    <div style="display: flex;flex-wrap: wrap;margin: 0 auto;width: 100%;min-width:100px;max-width:600px;overflow: auto;max-height: 95vh"
        class="customscroll">
        <ng-container *ngTemplateOutlet="loading ? myloading : svgmapinfo"></ng-container>
    </div>
</ng-template>

<ng-template #modeMobile>
    <div style="display: flex;flex-wrap: wrap;margin: 0 auto;width: 100%;overflow: auto;height: calc(100% - 45px)"
        class="customscroll">
        <ng-container *ngTemplateOutlet="loading ? myloading : svgmapinfo"></ng-container>
    </div>
</ng-template>
<ng-template #myloading>
    <div class="content-center">
        <div style="display: flex;justify-content: center;padding: .3rem; width: 100%;">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-template>
<ng-template #svgmapinfo>
    <div style="display: flex;flex-direction: column;height: max-content;overflow: hidden;">
        <div style="height: 400px;max-height: 40%;">
            <img class="lazyload" *ngIf="image?.length > 0" data-src="{{image}}"
                style="width: 100%;height: 100%; object-fit: cover;object-position: center;" alt="image">
        </div>
        <div style="padding: 1rem;height: auto;max-height: 40%;;overflow: hidden;text-overflow: ellipsis">
            <h1 multilang>{{title}}</h1>
            {{text}}
        </div>

        <button mat-button (click)="gotoContent()"
            style="margin: 1rem;padding: 0.5rem 1rem;width: calc(100% - 2rem);background-color:#0c3691eb;color: #fff;">
            <span multilang>Weitere Infos und Angebote ansehen</span>
        </button>

        <!--div style="display: flex;
            flex-direction: column;
            line-height: normal;margin: .5rem;" multilang [innerHTML]="html"></div-->

    </div>
</ng-template>